// entekhab
import E48 from 'assets/html-pwa/Entekhab/icon-48x48.png';
import E72 from 'assets/html-pwa/Entekhab/icon-72x72.png';
import E96 from 'assets/html-pwa/Entekhab/icon-96x96.png';
import E128 from 'assets/html-pwa/Entekhab/icon-128x128.png';
import E144 from 'assets/html-pwa/Entekhab/icon-144x144.png';
import E152 from 'assets/html-pwa/Entekhab/icon-152x152.png';
import E192 from 'assets/html-pwa/Entekhab/icon-192x192.png';
import E386 from 'assets/html-pwa/Entekhab/icon-384x384.png';
import E512 from 'assets/html-pwa/Entekhab/icon-512x512.png';

// keepa
import K48 from 'assets/html-pwa/Keepa/icon-48x48.png';
import K72 from 'assets/html-pwa/Keepa/icon-72x72.png';
import K96 from 'assets/html-pwa/Keepa/icon-96x96.png';
import K128 from 'assets/html-pwa/Keepa/icon-128x128.png';
import K144 from 'assets/html-pwa/Keepa/icon-144x144.png';
import K152 from 'assets/html-pwa/Keepa/icon-152x152.png';
import K192 from 'assets/html-pwa/Keepa/icon-192x192.png';
import K386 from 'assets/html-pwa/Keepa/icon-384x384.png';
import K512 from 'assets/html-pwa/Keepa/icon-512x512.png';

// hamtaland
import H48 from 'assets/html-pwa/Hamtaland/hamtaland - 48-min.png';
import H72 from 'assets/html-pwa/Hamtaland/hamtaland - 72-min.png';
import H96 from 'assets/html-pwa/Hamtaland/hamtaland -96-min.png';
import H128 from 'assets/html-pwa/Hamtaland/hamtaland - 128-min.png';
import H144 from 'assets/html-pwa/Hamtaland/hamtaland - 144-min.png';
import H152 from 'assets/html-pwa/Hamtaland/hamtaland - 152-min.png';
import H192 from 'assets/html-pwa/Hamtaland/hamtaland - 192-min.png';
import H384 from 'assets/html-pwa/Hamtaland/hamtaland - 384-min.png';
import H512 from 'assets/html-pwa/Hamtaland/hamtaland - 512-min.png';

// rayansaipa
import RS48 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-48-48.png';
import RS72 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-72-72.png';
import RS96 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-96-96.png';
import RS144 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-144-144.png';
import RS192 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-192-192.png';
import RS512 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-512-512.png';

// tisa
import Ti48 from 'assets/html-pwa/Tisa/48.png';
import Ti72 from 'assets/html-pwa/Tisa/72.png';
import Ti96 from 'assets/html-pwa/Tisa/96.png';
import Ti128 from 'assets/html-pwa/Tisa/128.png';
import Ti144 from 'assets/html-pwa/Tisa/144.png';
import Ti152 from 'assets/html-pwa/Tisa/152.png';
import Ti192 from 'assets/html-pwa/Tisa/176.png';
import Ti384 from 'assets/html-pwa/Tisa/348.png';
import Ti512 from 'assets/html-pwa/Tisa/512.png';

// saana
import SA48 from 'assets/html-pwa/Saana/48.png';
import SA72 from 'assets/html-pwa/Saana/72.png';
import SA96 from 'assets/html-pwa/Saana/96.png';
import SA128 from 'assets/html-pwa/Saana/128.png';
import SA144 from 'assets/html-pwa/Saana/144.png';
import SA152 from 'assets/html-pwa/Saana/152.png';
import SA192 from 'assets/html-pwa/Saana/176.png';
import SA384 from 'assets/html-pwa/Saana/384.png';
import SA512 from 'assets/html-pwa/Saana/512.png';

// arbaeen
import ARB48 from 'assets/html-pwa/Arbaeen/48.png';
import ARB72 from 'assets/html-pwa/Arbaeen/72.png';
import ARB96 from 'assets/html-pwa/Arbaeen/96.png';
import ARB128 from 'assets/html-pwa/Arbaeen/128.png';
import ARB144 from 'assets/html-pwa/Arbaeen/144.png';
import ARB152 from 'assets/html-pwa/Arbaeen/152.png';
import ARB192 from 'assets/html-pwa/Arbaeen/176.png';
import ARB384 from 'assets/html-pwa/Arbaeen/348.png';
import ARB512 from 'assets/html-pwa/Arbaeen/512.png';

// All other icon imports...

export const entekhabIcons = {
	48: E48,
	72: E72,
	96: E96,
	128: E128,
	144: E144,
	152: E152,
	192: E192,
	384: E386,
	512: E512,
};

export const keepaIcons = {
	48: K48,
	72: K72,
	96: K96,
	128: K128,
	144: K144,
	152: K152,
	192: K192,
	384: K386,
	512: K512,
};

export const hamtalandIcons = {
	48: H48,
	72: H72,
	96: H96,
	128: H128,
	144: H144,
	152: H152,
	192: H192,
	384: H384,
	512: H512,
};

export const rayansaipaIcons = {
	48: RS48,
	72: RS72,
	96: RS96,
	144: RS144,
	192: RS192,
	512: RS512,
};

export const tisaIcons = {
	48: Ti48,
	72: Ti72,
	96: Ti96,
	128: Ti128,
	144: Ti144,
	152: Ti152,
	192: Ti192,
	384: Ti384,
	512: Ti512,
};

export const saanaIcons = {
	48: SA48,
	72: SA72,
	96: SA96,
	128: SA128,
	144: SA144,
	152: SA152,
	192: SA192,
	384: SA384,
	512: SA512,
};

export const arbaeenIcons = {
	48: ARB48,
	72: ARB72,
	96: ARB96,
	128: ARB128,
	144: ARB144,
	152: ARB152,
	192: ARB192,
	384: ARB384,
	512: ARB512,
};

// Export other icon sets similarly...
